import { render, staticRenderFns } from "./onlineAndOfflineIntegration.vue?vue&type=template&id=b9045d80&scoped=true"
import script from "./onlineAndOfflineIntegration.vue?vue&type=script&lang=js"
export * from "./onlineAndOfflineIntegration.vue?vue&type=script&lang=js"
import style0 from "./onlineAndOfflineIntegration.vue?vue&type=style&index=0&id=b9045d80&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9045d80",
  null
  
)

export default component.exports